import { getInitialSettings } from '@api/getInitialSettings';
import {
  DivisionChartItemType,
  InitialSettingsResponseType,
} from '@type/dashboard';
import { useEffect, useState } from 'react';
import { useCustomParams } from './useCustomParams';

interface useInitialSettingsType {
  initialSettings: DivisionChartItemType[];
  isLoading: boolean;
}

export const useInitialSettings = (): useInitialSettingsType => {
  const [initialSettings, setInitialSettings] = useState<
    DivisionChartItemType[]
  >([]);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { searchParams } = useCustomParams();
  const election_schedule_id = searchParams.get('election_schedule_id');

  useEffect(() => {
    setIsLoading(true);
    if (election_schedule_id) {
      getInitialSettings(election_schedule_id)
        .then((data) => {
          if (data?.data || data?.data?.length > 0) {
            const modifiedData = data.data.map(
              (item: InitialSettingsResponseType) => {
                return {
                  id: item.id,
                  divisionId: item.division_code,
                  initialAsonId: item.settings_code,
                  name: item.name,
                  toggleDivision: true,
                  switchChartType: true,
                };
              },
            );
            setInitialSettings(modifiedData);
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  }, [election_schedule_id]);

  return {
    initialSettings,
    isLoading,
  };
};
